import { useAttachmentMetadata } from "@circle-react-shared/BuilderUI/Media/AttachmentContext";
import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

interface StylesBackgroundImageValue {
  placeholder: string;
  signed_id: string;
}

export const useResolvedBackgroundImage = (
  backgroundImage: StyleValue | undefined,
): string => {
  const { value } = backgroundImage || {};
  const { signed_id: backgroundImageSignedId, placeholder } =
    (value as StylesBackgroundImageValue) || {
      signed_id: "",
      placeholder: "",
    };

  const attachmentMetadata = useAttachmentMetadata(backgroundImageSignedId);
  const { url: attachmentUrl } = attachmentMetadata ?? {};

  return attachmentUrl || placeholder;
};
